(function () {
  var KEY = 'apex_compare';
  var MAX = 4;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    refreshUI();
  }
  function toggle(handle) {
    if (!handle) return;
    var items = read();
    var i = items.indexOf(handle);
    if (i >= 0) {
      items.splice(i, 1);
    } else {
      if (items.length >= MAX) {
        toast('Compare is full (max ' + MAX + ').');
        return;
      }
      items.push(handle);
    }
    write(items);
  }
  function remove(handle) {
    var items = read();
    var i = items.indexOf(handle);
    if (i >= 0) {
      items.splice(i, 1);
      write(items);
    }
  }
  function clear() { write([]); }

  function refreshUI() {
    var items = read();
    document.querySelectorAll('[data-apex-compare-toggle]').forEach(function (btn) {
      var on = items.indexOf(btn.dataset.productHandle) >= 0;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = btn.querySelector('[data-apex-compare-label]');
      if (lbl) lbl.textContent = on ? (btn.dataset.removeLabel || 'Remove') : (btn.dataset.addLabel || 'Compare');
    });
    var tray = document.getElementById('apex-compare-tray');
    if (!tray) return;
    if (items.length === 0) { tray.classList.remove('is-visible'); return; }
    tray.classList.add('is-visible');
    var list  = tray.querySelector('.apex-compare-tray__list');
    var count = tray.querySelector('.apex-compare-tray__count');
    if (list) {
      list.innerHTML = items.map(function (h) {
        var label = h.replace(/-/g, ' ');
        return '<button type="button" class="apex-compare-tray__chip" data-apex-compare-remove="' + h + '" aria-label="Remove ' + esc(label) + '">'
             + '<span>' + esc(label) + '</span>'
             + '<svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
             + '</button>';
      }).join('');
    }
    if (count) count.textContent = items.length + '/' + MAX;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function stripHtml(s) {
    var d = document.createElement('div');
    d.innerHTML = s || '';
    return (d.textContent || '').trim();
  }
  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      try { return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat); } catch (e) {}
    }
    return '₹' + (Math.round(cents) / 100).toFixed(0);
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'apex-compare-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () { t.classList.remove('is-visible'); }, 2400);
    setTimeout(function () { t.remove(); }, 2800);
  }

  function open() {
    var items = read();
    if (items.length < 2) { toast('Add at least 2 products to compare.'); return; }
    var modal = document.getElementById('apex-compare-modal');
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var body = modal.querySelector('.apex-compare-modal__body');
    body.innerHTML = '<div class="apex-compare-modal__loading">Loading…</div>';
    Promise.all(items.map(fetchProduct)).then(function (products) {
      products = products.filter(Boolean);
      if (products.length === 0) {
        body.innerHTML = '<p class="apex-compare-modal__empty">Could not load products.</p>';
        return;
      }
      body.innerHTML = renderCompare(products);
    });
  }
  function close() {
    var modal = document.getElementById('apex-compare-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function renderCompare(products) {
    var cols = products.map(function (p) {
      var img = p.featured_image
        ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=500" alt="' + esc(p.title) + '" loading="lazy">'
        : '';
      var was = (p.compare_at_price && p.compare_at_price > p.price)
        ? ' <s class="apex-compare-modal__was">' + money(p.compare_at_price) + '</s>'
        : '';
      var optsList = (p.options || []).filter(function (o) {
        if (!o || !o.name) return false;
        var vals = o.values || [];
        return !(o.name === 'Title' && vals.length === 1 && vals[0] === 'Default Title');
      }).map(function (o) {
        return '<div><b>' + esc(o.name) + ':</b> ' + esc((o.values || []).join(', ')) + '</div>';
      }).join('');
      var tagsList = (p.tags || []).slice(0, 6).map(function (t) {
        return '<span class="apex-compare-modal__tag">' + esc(t) + '</span>';
      }).join('');
      return ''
        + '<article class="apex-compare-modal__col">'
        +   '<button type="button" class="apex-compare-modal__remove" data-apex-compare-remove="' + p.handle + '" aria-label="Remove">'
        +     '<svg viewBox="0 0 16 16" width="14" height="14"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
        +   '</button>'
        +   '<div class="apex-compare-modal__img-wrap">' + img + '</div>'
        +   '<a href="' + p.url + '" class="apex-compare-modal__title">' + esc(p.title) + '</a>'
        +   '<div class="apex-compare-modal__price"><span class="apex-compare-modal__now">' + money(p.price) + '</span>' + was + '</div>'
        +   '<dl class="apex-compare-modal__specs">'
        +     (p.type      ? '<div><dt>Type</dt><dd>' + esc(p.type) + '</dd></div>' : '')
        +     '<div><dt>Stock</dt><dd>' + (p.available ? '<span class="apex-compare-modal__instock">In stock</span>' : 'Sold out') + '</dd></div>'
        +     (optsList    ? '<div><dt>Options</dt><dd>' + optsList + '</dd></div>' : '')
        +     (tagsList    ? '<div><dt>Features</dt><dd>' + tagsList + '</dd></div>' : '')
        +   '</dl>'
        +   '<a href="' + p.url + '" class="apex-compare-modal__cta">View product</a>'
        + '</article>';
    });
    return '<div class="apex-compare-modal__grid apex-compare-modal__grid--cols-' + products.length + '">' + cols.join('') + '</div>';
  }

  function init() {
    document.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-apex-compare-toggle]'))) {
        e.preventDefault();
        toggle(t.dataset.productHandle);
        return;
      }
      if ((t = e.target.closest('[data-apex-compare-remove]'))) {
        e.preventDefault();
        var h = t.dataset.apexCompareRemove;
        remove(h);
        var modal = document.getElementById('apex-compare-modal');
        if (modal && modal.classList.contains('is-open')) {
          var left = read();
          if (left.length < 2) close();
          else open();
        }
        return;
      }
      if (e.target.closest('#apex-compare-open')) { e.preventDefault(); open(); return; }
      if (e.target.closest('#apex-compare-clear')) { e.preventDefault(); clear(); return; }
      if (e.target.closest('.apex-compare-modal__close') || e.target.classList.contains('apex-compare-modal__overlay')) {
        e.preventDefault(); close(); return;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('storage', function (e) { if (e.key === KEY) refreshUI(); });
    refreshUI();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
